import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UsersConstants} from '../../constants/users.constants';
import ROLES = UsersConstants.ROLES;

@Injectable({
  providedIn: 'root'
})
export class ReferentialService {

  constructor(private http: HttpClient) {

  }

  public getUnits() {
    return this.http.get(`units`);
  }

  public getDeviceTypes() {
    return this.http.get(`device-types`);
  }

  public getReferential(type: string) {
    return this.http.get(`references/` + type);
  }

  public getLengthForLiris() {
    return [{value: 1, name: '1'}, {value: 2, name: '2'}];
  }

  public getLengthForOptV5() {
    return [{value: 1, name: '1'}, {value: 2, name: '2'}, {value: 5, name: '5'}, {value: 4.3, name: '4.30'}, {value: 10, name: '10'}];
  }

  getAlarmType() {
    return this.http.get('references/alarm-type');
  }

  public getTypeOptV5() {
    return [
      {
        value: 'corde-optique',
        name: 'corde-optique'
      }, {
        value: 'extensometre-magnetique',
        name: 'extensometre-magnetique'
      }
    ];

  }

  public getUserRolesForLevelAdmin() {
    return [
      {displayedValue: 'User', value: ROLES.ROLE_OSMOS_USER, selected: false},
      {displayedValue: 'Client', value: ROLES.ROLE_CLIENT, selected: false},
      {displayedValue: 'Installer', value: ROLES.ROLE_INSTALLER, selected: false},
      {displayedValue: 'Level admininistrator', value: ROLES.ROLE_ADMIN, selected: false},
      {displayedValue: 'Engineer', value: ROLES.ROLE_BE, selected: false},
      {displayedValue: 'Production', value: ROLES.ROLE_PRODUCTION, selected: false},
      {displayedValue: 'Data scientist', value: ROLES.ROLE_MATHS, selected: false},
      {displayedValue: 'Multi levels for Safe Analyzer', value: ROLES.ROLE_SAFE_ALL_LEVELS, selected: false},
      {displayedValue: 'Business', value: ROLES.ROLE_COMMERCIAL, selected: false},
      {displayedValue: 'Contact', value: ROLES.ROLE_CONTACT, selected: false},
      {displayedValue: 'Alarm validator', value: ROLES.ROLE_ALARM_VALIDATOR, selected: false},
    ];
  }

  public getUserRolesForUser() {
    return [
      {displayedValue: 'Client', value: ROLES.ROLE_CLIENT, selected: false},
      {displayedValue: 'Installer', value: ROLES.ROLE_INSTALLER, selected: false},
      {displayedValue: 'Contact', value: ROLES.ROLE_CONTACT, selected: false}
    ];
  }
}
